// PESTAÑAS DE MÓDULO (F3 reorden 24-oct-2026). «Una función = una pantalla con pestañas»: Gift Cards (Enviar · Ajustes),
// Referidos (Historial · Ajustes · Mensaje), Membresías (Planes y miembros · Avisos). La pestaña activa va en la URL
// (?tab=<id>) para que los enlaces de otras pantallas y el FAQ caigan en la pestaña correcta; sin ?tab se abre la primera.
// Mismo lenguaje visual que las 5 pestañas de Mi Negocio (BusinessForm), sin la línea de pregunta.
import React from 'react';
import { useSearchParams } from 'react-router-dom';

export interface PestanaModulo {
  id: string;
  label: string;
  icon?: React.ElementType;
}

/** Lee la pestaña activa de ?tab=; si no existe o no está en la lista, la primera. */
export function usePestanaActiva(ids: readonly string[], alias: Record<string, string> = {}): string {
  const [params] = useSearchParams();
  const v = params.get('tab') || '';
  const real = alias[v] || v;
  return ids.includes(real) ? real : ids[0];
}

const PestanasModulo: React.FC<{ tabs: PestanaModulo[]; activa: string; testid?: string }> = ({ tabs, activa, testid = 'pestanas-modulo' }) => {
  const [, setParams] = useSearchParams();
  const ir = (id: string) => setParams((p) => { const n = new URLSearchParams(p); n.set('tab', id); return n; }, { replace: true });
  return (
    <div className="flex gap-1 border-b border-line overflow-x-auto -mx-2 px-2 sm:mx-0 sm:px-0" role="tablist" data-testid={testid}>
      {tabs.map((t) => {
        const Icon = t.icon;
        const on = t.id === activa;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={on}
            data-testid={`${testid}-${t.id}`}
            onClick={() => ir(t.id)}
            className={`flex items-center gap-2 whitespace-nowrap rounded-t-md border-b-2 px-3 sm:px-4 pt-2 pb-2 text-sm font-medium transition-colors -mb-px ${
              on ? 'border-accent text-accent' : 'border-transparent text-content-2 hover:text-content hover:bg-surface-2'
            }`}
          >
            {Icon && <Icon className="h-4 w-4 flex-shrink-0" />}
            {t.label}
          </button>
        );
      })}
    </div>
  );
};

export default PestanasModulo;
